import { type ReactNode } from 'react'
import { Icon } from './Icon'
import { Logo } from './Logo'

interface HeaderProps {
  title?: string
  showBack?: boolean
  onBack?: () => void
  showLogo?: boolean
  rightAction?: ReactNode
  borderless?: boolean
}

export function Header({ title, showBack = false, onBack, showLogo = false, rightAction, borderless = false }: HeaderProps) {
  return (
    <header className={`flex items-center justify-between px-4 py-4 bg-[var(--color-surface)] ${borderless ? '' : 'border-b border-[var(--color-border)]'}`}>
      {/* Left side */}
      {showBack ? (
        <button
          onClick={onBack}
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors"
        >
          <Icon name="arrow-left" size={24} className="text-[var(--color-text)]" />
        </button>
      ) : (
        <div className="w-10" />
      )}

      {/* Center */}
      {showLogo ? (
        <Logo variant="full" size="sm" />
      ) : title ? (
        <h1 className="text-lg font-semibold text-[var(--color-text)]">{title}</h1>
      ) : (
        <div />
      )}

      {/* Right side */}
      {rightAction ? rightAction : <div className="w-10" />}
    </header>
  )
}
